@let items = (containers$ | async) ?? [];

<div class="container-selector">
  <lib-table
    #tableHost
    class="container-selector__table"
    [columns]="CONTAINER_COLUMNS"
    [dataSource]="items"
    [loaded]="facilityId !== undefined && hasLoaded()"
    [loading]="facilityId !== undefined && isLoading()"
    [cellTemplates]="{
      name: nameTpl,
      mask: maskTpl,
    }"
    [headerTemplates]="{
      name: nameHeaderTpl,
    }"
    emptyState="monitoring.nothing-found"
  />

  <ng-template #nameHeaderTpl>
    <div class="container-selector__name-cell container-selector__name-cell--header">
      <lib-checkbox
        [disabled]="facilityId === undefined || items.length === 0"
        [ngModel]="isAllVisibleSelected(items)"
        [ngModelOptions]="{ standalone: true }"
        (ngModelChange)="toggleAllVisible($event, items)"
      >
        <span class="container-selector__name-title">
          {{ 'monitoring.scanner.new-scan.container' | translate }}
        </span>
      </lib-checkbox>
    </div>
  </ng-template>

  <ng-template
    #nameTpl
    let-row="data"
  >
    @let data = asContainerMaskItem(row);
    <div class="container-selector__name-cell">
      <lib-checkbox
        [disabled]="facilityId === undefined"
        [ngModel]="isContainerSelected(data.id)"
        [ngModelOptions]="{ standalone: true }"
        (ngModelChange)="toggleContainer($event, data.id)"
      >
        <span class="container-selector__name">{{ data.name }}</span>
      </lib-checkbox>
    </div>
  </ng-template>

  <ng-template
    #maskTpl
    let-row="data"
  >
    @let data = asContainerMaskItem(row);
    <div class="container-selector__mask-cell">
      @for (maskItem of data.mask; track $index) {
        <span class="container-selector__mask-item">{{ maskItem }}</span>
      }
    </div>
  </ng-template>
</div>
